// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"1e48d0ec","743":"73cebb1c","767":"73f3898f","781":"d7379e99","993":"73cebb1c"}[chunkId] + ".css";
};